import { createStudioService } from './StudioService.impl';

export const myStudioService = createStudioService();
